import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkDialog, UitkDialogContent, UitkDialogFooter, UitkDialogFooterProps } from 'uitk-react-dialog';

export interface InfoModalProps {
  children?: any;
  closeA11yLabel?: string;
  onClose?: () => any;
  actions?: UitkDialogFooterProps;
}

export const InfoModal: React.FunctionComponent<InfoModalProps> = props => {
  const focusRef = React.useRef(null);

  const l10n = useLocalization();

  React.useEffect(() => {
    if (focusRef && focusRef.current && typeof focusRef.current.focus === 'function') {
      focusRef.current.focus();
    }
  }, []);

  const { children, closeA11yLabel, onClose, actions } = props;

  const closeLabel = closeA11yLabel || l10n.formatText('hotels.infosite.rateInfoDialog.cancelButton.a11yLabel');

  const footerProps = actions || { buttonOne: { onClick: onClose, text: closeLabel, type: 'tertiary' } };

  return (
    <UitkDialog>
      <UitkDialogContent>
        <div ref={focusRef} tabIndex={0}>
          {children}
        </div>
      </UitkDialogContent>
      <UitkDialogFooter {...footerProps} />
    </UitkDialog>
  );
};
InfoModal.displayName = 'InfoModal';
